import { DAEMON_URL } from "../config";
import { parseSseStream } from "./sse";
import { HttpError } from "./errors";
import type { StreamEvent, ChatRequest } from "./types";

export async function* sendChat(
  req: ChatRequest,
): AsyncGenerator<StreamEvent, void, void> {
  const url = `${DAEMON_URL}/chat/${encodeURIComponent(req.project)}`;
  let res: Response;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/event-stream",
      },
      credentials: "include",
      body: JSON.stringify({ message: req.message }),
    });
  } catch (e) {
    yield { type: "error", error: `network error: ${(e as Error).message}` };
    return;
  }

  if (res.status === 401) {
    throw new HttpError(401, "unauthorized");
  }
  if (res.status === 403) {
    throw new HttpError(403, "forbidden");
  }
  if (res.status !== 200) {
    throw new HttpError(res.status, `http ${res.status}`);
  }
  if (!res.body) {
    yield { type: "error", error: "empty response body" };
    return;
  }

  yield* parseSseStream(res.body);
}

export async function stopChat(project: string): Promise<{ interrupted: boolean }> {
  const url = `${DAEMON_URL}/chat/${encodeURIComponent(project)}/stop`;
  let res: Response;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: { "Accept": "application/json" },
      credentials: "include",
    });
  } catch (e) {
    throw new Error(`network error: ${(e as Error).message}`);
  }
  if (res.status === 401) throw new HttpError(401, "unauthorized");
  if (res.status === 403) throw new HttpError(403, "forbidden");
  if (res.status !== 200) throw new HttpError(res.status, `http ${res.status}`);
  return (await res.json()) as { interrupted: boolean };
}
